'use client';

import Link from 'next/link';
import {useTranslations} from 'next-intl';
import { SignOut } from '@/utils/auth-helpers/server';
import { handleRequest } from '@/utils/auth-helpers/client';
import { usePathname, useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { getRedirectMethod } from '@/utils/auth-helpers/settings';
import s from './Navbar.module.css';
import Image from 'next/image';
import {UserNav} from '../user-nav';
import { Users } from 'lucide-react';
interface NavlinksProps {
  user?: any;
  role?: string | null;
}

export default function Navlinks({ user, role }: NavlinksProps) {
  const router = getRedirectMethod() === 'client' ? useRouter() : null;
  const t = useTranslations()

  return (
    <div className="relative flex flex-row justify-between align-center py-4">
      <div className="flex items-center flex-1">
        <Link href="/" className={s.logo} aria-label="Logo">
          <Image src='/logo.png' width={50} height={50} alt='' className='m-auto' />
        </Link>
        <nav className="ml-6 space-x-2 lg:block">
          {user && (
            <Link href="/projects" className={s.link}>
              {t('myProjects')}
            </Link>
          )}
          {role === 'admin' && (
            <Link href="/admin/assistants" className={s.link}>
              {t('admin.assistants')}
            </Link>
          )}
          {role === 'admin' && (
            <Link href="/admin/offers" className={s.link}>
              {t('admin.offers')}
            </Link>
          )}
          {/* {role === 'admin' && (
            <Link href="/admin/dashboard" className={s.link}>
              {t('admin.dashboard')}
            </Link>
          )} */}
        </nav>
      </div>
      <div className="flex justify-end space-x-8">
        {user ? (
          <UserNav user={user}/>
        ) : (
          <>
          <Link href="/signin/signup" className={s.link}>
            {t('menu.register')}
          </Link>
          <Link href="/signin" className={s.link}>
            <Button variant="secondary">
            {t('menu.signin')}
            </Button>
          </Link>
          </>
        )}
      </div>
    </div>
  );
}
